import { render, staticRenderFns } from "./pledgeFilBalanceDetail.vue?vue&type=template&id=87e11f3c&scoped=true&"
import script from "./pledgeFilBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./pledgeFilBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./pledgeFilBalanceDetail.vue?vue&type=style&index=0&id=87e11f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e11f3c",
  null
  
)

export default component.exports